import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import BaseModal from './BaseModal.js';
import { jsx } from 'react/jsx-runtime';
import useIsMobile from '../../hooks/useIsMobile.js';
import DraggableDrawer from '../DraggableDrawer/DraggableDrawer.js';

var _excluded = ["children", "heading", "initialIsMobile", "isOpen", "nonClosable", "onClose", "overlaidCloseButton", "size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Modal = function Modal(_ref) {
  var children = _ref.children,
    _ref$heading = _ref.heading,
    heading = _ref$heading === void 0 ? null : _ref$heading,
    _ref$initialIsMobile = _ref.initialIsMobile,
    initialIsMobile = _ref$initialIsMobile === void 0 ? false : _ref$initialIsMobile,
    _ref$isOpen = _ref.isOpen,
    isOpen = _ref$isOpen === void 0 ? true : _ref$isOpen,
    _ref$nonClosable = _ref.nonClosable,
    nonClosable = _ref$nonClosable === void 0 ? false : _ref$nonClosable,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose,
    _ref$overlaidCloseBut = _ref.overlaidCloseButton,
    overlaidCloseButton = _ref$overlaidCloseBut === void 0 ? false : _ref$overlaidCloseBut,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'm' : _ref$size,
    rest = _objectWithoutProperties(_ref, _excluded);
  var isMobile = useIsMobile(initialIsMobile);
  var renderDraggableDrawer = isMobile;
  return renderDraggableDrawer ? /*#__PURE__*/jsx(DraggableDrawer, _objectSpread(_objectSpread({
    defaultHeight: 85,
    heading: heading,
    nonClosable: nonClosable,
    onClose: onClose,
    show: isOpen
  }, rest), {}, {
    children: children
  })) : /*#__PURE__*/jsx(BaseModal, _objectSpread(_objectSpread({
    heading: heading,
    isOpen: isOpen,
    nonClosable: nonClosable,
    onClose: onClose,
    overlaidCloseButton: overlaidCloseButton,
    size: size
  }, rest), {}, {
    children: children
  }));
};
var Modal$1 = Modal;

export { Modal$1 as default };
//# sourceMappingURL=Modal.js.map
